import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createTranslateLoader } from '../../http-loader-factory';
import { ScenarioItemComponent } from './scenario-item.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LoaderModule } from '../../components/loader/loader.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { UploadFileWithProgressComponent } from '../../../admin/components/upload-file-with-progress/upload-file-with-progress.component';
import { MatTabsModule } from '@angular/material/tabs';
import { CustomPipeModule } from '../../pipes/custom-pipe.module';
import { MatChip, MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatMenuModule } from '@angular/material/menu';
import { FileUploadComponent } from '../../../admin/components/file-upload/file-upload.component';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  OWL_DATE_TIME_LOCALE,
} from '@danielmoncada/angular-datetime-picker';

import { MessagesComponent } from '../../components/form-messages-component/messages.component';
import { FormWebPostDataComponent } from '../../components/form-web-post-data/form-web-post-data.component';
import { FormRansomwareLeakSiteComponent } from '../../components/form-ransomware-leak-site/form-ransomware-leak-site.component';
import { FormBranchingComponent } from '../../components/form-branching/form-branching.component';
import { ValidateResponseComponent } from '../../components/validate-response-form/validate-response.component';

@NgModule({
  declarations: [ScenarioItemComponent],
  providers: [{ provide: OWL_DATE_TIME_LOCALE, useValue: 'en-GB' }],
  exports: [ScenarioItemComponent],
  imports: [
    FormBranchingComponent,
    FormRansomwareLeakSiteComponent,
    FormWebPostDataComponent,
    UploadFileWithProgressComponent,
    AngularSvgIconModule,
    CommonModule,
    MatMenuModule,
    MatDialogModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatIconModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    LoaderModule,
    MatTabsModule,
    CustomPipeModule,
    MatChipsModule,
    FileUploadComponent,
    OwlDateTimeModule,
    ValidateResponseComponent,
    OwlNativeDateTimeModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    MatChip,
    MessagesComponent,
  ],
})
export class ScenarioItemModule {}
